import { render, staticRenderFns } from "./NTelInput.vue?vue&type=template&id=a59e83dc&scoped=true&"
import script from "./NTelInput.vue?vue&type=script&lang=js&"
export * from "./NTelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59e83dc",
  null
  
)

export default component.exports